export const OG_TYPE = 'website'

export const TWITTER_NAME = '@ApeironNFT'

export const FACEBOOK_APP_ID = ''
